/**
 * Trigger a browser download of an in-memory blob (e.g. a CSV fetched with the
 * auth header, which can't be a plain navigation).
 *
 * The anchor MUST be appended to the document before `click()` — several
 * browsers ignore the `download` attribute on a detached anchor and fall back to
 * naming the file after the blob URL's UUID (which shows up as a blank/garbage
 * name). Revoking the object URL is likewise deferred until after the click.
 */
export function downloadBlob(
  data: BlobPart,
  filename: string,
  mime = 'application/octet-stream',
): void {
  const url = URL.createObjectURL(new Blob([data], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
